var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v(_vm._s(_vm.item.question.title))]),_c('div',[_vm._v("\n    "+_vm._s(_vm.item.answer.value || _vm.item.answer)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }